module.exports = __webpack_public_path__ + "MuseoSans-500Italic.7931ad532e432e520b6a.eot";


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/assets/fonts/MuseoSans-500Italic.eot
// module id = ../../../../../src/assets/fonts/MuseoSans-500Italic.eot
// module chunks = styles